export default function WhyProgramsWork() {
  const steps = [
    {
      number: '01',
      title: 'Диагностика',
      desc: 'Прослушиваем реальные звонки, анализируем CRM, выявляем слабые места и точки роста.',
    },
    {
      number: '02',
      title: 'Программа под компанию',
      desc: 'Каждый модуль адаптируется под ваш продукт, рынок и типичные сценарии холодных звонков.',
    },
    {
      number: '03',
      title: 'Практика на ваших звонках',
      desc: '80% времени — отработка на реальных разговорах менеджеров с детальной обратной связью.',
    },
    {
      number: '04',
      title: 'Домашние задания',
      desc: 'Между модулями сотрудники применяют навыки и получают разбор результатов.',
    },
    {
      number: '05',
      title: 'Сопровождение внедрения',
      desc: 'Поддержка после тренинга: разборы звонков, корректировка, чат с тренером.',
    },
  ];

  return (
    <section id="why-work" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему наши программы работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Именно эта последовательность превращает обучение в реальные изменения поведения сотрудников и измеримый рост показателей.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 max-w-6xl mx-auto mb-12">
          {steps.map((step, i) => (
            <div key={i} className="flex-1 bg-gray-50 rounded-xl p-6 text-center hover:bg-teal-50 transition-colors duration-300 border border-gray-100 hover:border-teal-200 relative">
              <div className="text-5xl font-extrabold text-teal-200 mb-3">{step.number}</div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
              {i < 4 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-teal-50 rounded-2xl p-8 border border-teal-200">
            <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-focus-3-line text-xl text-white"></i>
            </div>
            <p className="text-lg text-gray-900 font-semibold leading-relaxed">
              Мы обучаем сотрудников работать именно с теми клиентами, которым они звонят каждый день.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}